<template>
  <AuthCard>
    <div><h3 class="text-center">Sign up</h3></div>
    <form @submit.prevent="signup">
      <Input v-model="email" label="E-mail" name="email" :disabled="loading" />
      <Input
        v-model="password"
        label="Password"
        name="password"
        type="password"
        :disabled="loading"
        :error="error"
        class="my-4"
      />
      <Input
        v-model="confirmPassword"
        label="Confirm password"
        name="confirmPassword"
        type="password"
        :disabled="loading"
        :error="error"
        class="my-4"
      />
      <label class="terms-check">
        <input type="checkbox" v-model="acceptedTerms" :disabled="loading" />
        <span>I agree to the <router-link to="/terms" target="_blank">Terms of Service</router-link> and <router-link to="/privacy" target="_blank">Privacy Policy</router-link></span>
      </label>
      <div class="flex wrap align-center mt-4">
        <div class="xs12">
          <Button
            type="submit"
            variant="smooth primary"
            :disabled="loading || !password || password !== confirmPassword || !acceptedTerms"
            :loading="loading"
            class="mb-2 width100"
          >
            Sign up
          </Button>
        </div>
        <div class="xs12 flex justify-center pt-5">
          Already have an account?
          <router-link class="ml-3" to="signin">Sign in</router-link>
        </div>
      </div>
    </form>
  </AuthCard>
</template>

<script>
  import Input from '../common/Input.vue'
  import Button from '../common/Button.vue'
  import AuthCard from '../common/AuthCard.vue'

  export default {
    name: 'SignUp',
    components: { Input, Button, AuthCard },
    data: () => ({
      email: '',
      password: '',
      confirmPassword: '',
      acceptedTerms: false,
      loading: false,
      error: ''
    }),
    methods: {
      async signup() {
        this.loading = true
        this.error = ''
        try {
          await this.$store.dispatch('signup', { email: this.email, password: this.password })
          this.$router.push({ name: 'confirmregistrationcheckemail' })
        } catch (err) {
          this.error = err?.response?.data?.message || err?.message || 'Something went wrong. Please try again.'
        } finally {
          this.loading = false
        }
      }
    }
  }
</script>

<style scoped>
.terms-check {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  font-size: 0.82rem;
  color: var(--text-secondary, #555);
  cursor: pointer;
  line-height: 1.5;
  margin-top: 0.25rem;
}

.terms-check input[type="checkbox"] {
  margin-top: 2px;
  flex-shrink: 0;
  accent-color: var(--primary, #5B8DB8);
  width: 15px;
  height: 15px;
  cursor: pointer;
}

.terms-check a {
  color: var(--primary, #5B8DB8);
  text-decoration: none;
  font-weight: 500;
}

.terms-check a:hover {
  text-decoration: underline;
}
</style>
